import { secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  white-space: nowrap;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    gap: 1.6rem;
  }
`;

export const StyledWrapRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;

  &:first-child {
    z-index: 2;
  }
  &:nth-child(2) {
    z-index: 1;

    ::before {
      content: '';
      position: absolute;
      bottom: -260px;
      right: 0px;
      width: 868px;
      height: 398px;
      background: radial-gradient(50% 50% at 50% 50%, rgb(62, 71, 90) 0%, rgba(21, 28, 43, 0) 100%);
      z-index: -1;
    }
  }
`;

export const StyledBar = styled.div<{ $thin: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.4rem 1.2rem;
  gap: 2.4rem;
  background: ${secondaryColors.offBlack};
  overflow: hidden;
  position: relative;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
    flex-wrap: wrap;
    flex-basis: 9.7rem;
    flex-shrink: 0;
    justify-content: center;
  }

  ::before {
    content: '';
    position: absolute;
    left: -189px;
    top: -260px;
    width: 868px;
    height: 398px;
    background: radial-gradient(50% 50% at 50% 50%, #3e475a 0%, rgba(21, 28, 43, 0) 100%);
  }
`;

export const StyledText = styled.p`
  font-size: 2.4rem;
  font-weight: 800;
  line-height: 100%;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.main};

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 2.8rem;
  }
`;

export const StyledHighlight = styled.span`
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

export const ButtonWrapper = styled.div`
  position: relative;
`;

export const StyledImage = styled.img`
  width: 5.2rem;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(12px, -21px) rotate(22.25deg);
`;
